import * as ACTION_TYPES from '@actions/action_types'
// import { AutomationEmailInterface } from '@interfaces/automation_emails';
export interface AutomationEmailsStateType {
  automation_email: typeof ACTION_TYPES.newAutomationEmail
}
export const initialState = {
  automation_email: ACTION_TYPES.newAutomationEmail,
}
export const AutomationEmailsReducer = (
  state: AutomationEmailsStateType,
  action: A,
) => {
  switch (action.type) {
    case ACTION_TYPES.SHOW_AUTOMATION_EMAIL:
      return { ...state, automation_email: action.automation_email }
    default:
      return state
  }
}
export default AutomationEmailsReducer
